/*
 * --------------------------------------------------------------------
 * File: \src\app\store.js
 * Created: Thursday, 26th September 2024 2:03:29 pm
 * Modified: Thursday, 26th September 2024 2:03:29 pm
 * Author: Mohamed Kamil Bin Mansor
 * 
 * Copyright (c) 2024 - System Consultancy Services Sdn. Bhd.
 * --------------------------------------------------------------------
 */

import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import appReducer from "./appSlice";
import mapReducer from "./mapSlice";
import dashboardReducer from "./dashboardSlice";
import adminReducer from "./adminSlice";
import websocketReducer from "./websocketSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    app: appReducer,
    map: mapReducer,
    dashboard: dashboardReducer,
    admin: adminReducer,
    websocket: websocketReducer,
  },
});
